import MailTo from '../../modules/components/MailTo';

export default MailTo;



// WEBPACK FOOTER //
// ./src/components/shared/MailTo.js